export enum RowColor {
  LIGHT_BLUE = 'super-app-theme--lightBlue',
  LIGHT_GREEN = 'super-app-theme--lightGreen',
  LIGHT_YELLOW = 'super-app-theme--lightYellow',
}
